import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayModes } from '../../../models/enums';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { VisitChannelsService } from '../visit-channels.service';

@Component({
  selector: 'crm-add-visit-channel',
  templateUrl: './add-visit-channel.component.html',
  styleUrls: ['./add-visit-channel.component.css']
})
export class AddVisitChannelComponent implements OnInit {

  displayMode: DisplayModes = DisplayModes.Success;
  visitChannel: any = {} as any


  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() visitChannelId: number;
  constructor(private readonly visitChannelService: VisitChannelsService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly translateService: AppTranslationService,
    private readonly alertService: AlertService) { }

  ngOnInit() {
    if (this.visitChannelId != undefined)
      this.getVisitChannel(this.visitChannelId);
  }

  getVisitChannel(visitChannelId) {
    this.displayMode = DisplayModes.Loading;
    this.visitChannelService.getById(visitChannelId).subscribe(responce => {
      this.displayMode = DisplayModes.Success;
      this.visitChannel = responce as any;
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get visitChannel');
        console.log(err);
      });
  }

  save(form) {
    if (!form.invalid) {

      this.displayMode = DisplayModes.Loading;

      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
      this.visitChannelService.save(this.visitChannel).subscribe(() => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        this.back();
        this.alertService.showMessage("", this.translateService.getTranslation("clm.savedSuccessfully"), MessageSeverity.Success);
      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
    }
  }

  back() {
    this.closeEvent.emit(true);
  }

}
